const DAY_MS = 24 * 60 * 60 * 1000;

export const PAYMENT_OVERDUE_GRACE_DAYS = 7;

export type PaymentOverdueInfo = {
  paymentDeadlineMs: number;
  paymentDeadlineDate: Date;
  overdueMsAfterGrace: number;
  overdueDaysAfterGrace: number;
};

/**
 * Interprets `payment_deadline` as the tenant's monthly billing due date.
 * A tenant is considered "overdue" when they are more than PAYMENT_OVERDUE_GRACE_DAYS late.
 */
export function getPaymentOverdueInfo(
  paymentDeadline?: string | null
): PaymentOverdueInfo | null {
  if (!paymentDeadline) return null;
  const paymentDeadlineMs = new Date(paymentDeadline).getTime();
  if (!Number.isFinite(paymentDeadlineMs)) return null;

  const overdueMsAfterGrace =
    Date.now() - paymentDeadlineMs - PAYMENT_OVERDUE_GRACE_DAYS * DAY_MS;

  if (overdueMsAfterGrace <= 0) return null;

  const overdueDaysAfterGrace = Math.ceil(overdueMsAfterGrace / DAY_MS);

  return {
    paymentDeadlineMs,
    paymentDeadlineDate: new Date(paymentDeadlineMs),
    overdueMsAfterGrace,
    overdueDaysAfterGrace,
  };
}


